<div class="itb-feedback-container">
  <div class="feedback-browser">
    <div class="browser-top">
      <strong class="header-text"
        ><itb-text
          [className]="'text-default'"
          [text]="'Email Application'"
        ></itb-text
      ></strong>
      <div class="browser-icons">
        <div class="red"></div>
        <div class="yellow"></div>
        <div class="green"></div>
      </div>
    </div>
    <div class="browser-fields">
      <span><strong>From:&nbsp;</strong> support@organization.com</span>
      <span><strong>To:&nbsp;</strong> client@organization.com</span>
      <span
        ><strong>Subject:&nbsp;</strong> Service Ticket #12345/has been
        completed</span
      >
    </div>
    <div class="browser-body email-t">
        <p class="dummy-data dMedium"></p>
        <p class="dummy-data dLarge"></p>
  
      <div *ngIf="editForm === false">
        <p>
          <itb-text [className]="'text-default'" [text]="tempEmailField"></itb-text>
          <itb-icon [hidden]="isDisabled"
            [tooltipText]="'Update'"
            [className]="'edit'"
            (onClickHandler)="toggleEvent()"
          ></itb-icon>
        </p>
      </div>

      <div class="text-edit" *ngIf="editForm === true">
        <div>
          <form>
            <itb-textarea
              [isReactive]=false
              [rows]="'10'"
              [placeholder]=""
              [maxlength]="emailMaxLength"
              [value]="tempEmailField"
              (onTextChangeHandler)="onEmailChange($event)"
            >
            </itb-textarea>
          </form>
        </div>
        <div class="edit-icon">          
          <itb-icon
            [hidden]="tempEmailField.trim().length === 0"
            [tooltipText]="'Save'"
            [className]="'save'"
            (onClickHandler)="updateInput()"
          ></itb-icon>
          <itb-icon
            [tooltipText]="'Cancel'"
            [className]="'cross'"
            (onClickHandler)="toggleEvent()"
          ></itb-icon>
        </div>
      </div>
      <div class="tem-smily"> 
          <img class="img-responsive" src="images-library/smiley-happy.png" width="55px">
          <img class="img-responsive" src="images-library/smiley-satified.png" width="55px">
          <img class="img-responsive" src="images-library/smiley-neutral.png" width="55px">
          <img class="img-responsive" src="images-library/smiley-confuse.png" width="55px">
          <img class="img-responsive" src="images-library/smiley-poor.png" width="55px">
      </div>
      <p class="dummy-data dMedium"></p>
      <p class="dummy-data dLarge"></p>
      <p class="dummy-data dSmall"></p>

    </div>
  </div>
</div>
